// extracted by mini-css-extract-plugin
export default {"productGrid":"l5-z","centerLink":"m5-z","productSection":"n5-z","item":"o5-z","ctaButton":"p5-z"};